import { render, staticRenderFns } from "./SbolDetailInitialPage.vue?vue&type=template&id=fa8bff12&scoped=true&"
import script from "./SbolDetailInitialPage.vue?vue&type=script&lang=js&"
export * from "./SbolDetailInitialPage.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./SbolDetailInitialPage.vue?vue&type=style&index=0&id=fa8bff12&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "fa8bff12",
  null
  ,true
)

export default component.exports